import { render, staticRenderFns } from "./importStudent.vue?vue&type=template&id=6134bc70&scoped=true&"
import script from "./importStudent.vue?vue&type=script&lang=js&"
export * from "./importStudent.vue?vue&type=script&lang=js&"
import style0 from "./importStudent.vue?vue&type=style&index=0&id=6134bc70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6134bc70",
  null
  
)

export default component.exports